import React from 'react';
import { intersection } from 'lodash/fp';

import html2canvas from 'html2canvas';
import FileSaver from 'file-saver';

import withQueryParams, {
    WithQueryParamsInjectedProps,
} from '@ihme/common/utility/hoc/with-query-params';
import { withStorage, WithStorageProps } from '@ihme/common/packages/storage';
import _ from '@ihme/common/locale';

import api from '../../api';
import config from '../../config';

import View from './View';

type Filters = { location_id?: string };
type Props = WithQueryParamsInjectedProps<Filters> & WithStorageProps;

type State = {
    locations: number[];
    locationId: number;
};

class FactsheetsScene extends React.Component<Props, State> {
    state: State = {
        locations: [],
        locationId: this.props.queryParams.location_id
            ? parseInt(this.props.queryParams.location_id)
            : config.defaultFactsheetsLocationId,
    };

    componentDidMount(): void {
        this.loadLocations();
    }

    loadLocations = () => {
        const { cached } = this.props;

        Promise.all([
            cached(api.getLocations)(),
            cached(api.data.getCauseOutcomeFilters)(),
            cached(api.data.getRiskAttributionFilters)(),
        ])
            .then(([ locationHierarchy, causeFilters, risksFilters ]) => {
                const countries = locationHierarchy
                    .filter(location => location.type_id === config.countryLocationType)
                    .map(location => location.id);

                const sharedLocations = intersection(
                    causeFilters.location_id,
                    risksFilters.location_id
                ).filter(id => countries.includes(id));

                this.setState({ locations: sharedLocations });
            })
            .catch(console.log);
    };

    onLocationChange = (id: number) => {
        if (id !== this.state.locationId) {
            this.props.setQueryParams({
                location_id: id.toString(),
            });
            this.setState({
                locationId: id,
            });
        }
    };

    onScreenshot = (view) => {
        const { locationId } = this.state;
        const locationName = _(`location_${locationId}`);
        const fileName = `Factsheets About Cardiovascular Diseases In ${locationName}.png`;

        html2canvas(view, { useCORS: true, logging: false })
            .then(canvas => {
                canvas.toBlob(blob =>
                    FileSaver.saveAs(blob, fileName)
                )
            })
            .catch(console.err);
    };

    render() {
        const { locations, locationId } = this.state;

        return (
            <View
                locationId={locationId}
                onLocationChange={this.onLocationChange}
                locations={locations}
                onScreenshot={this.onScreenshot}
            />
        );
    }
}

export default withQueryParams(withStorage(FactsheetsScene));
